import axios from "../config/axiosInstance";
import endpoints from "./endpoints";

export const getPurchaseOrderReports = async (details) => {
  const response = await axios.put(
    endpoints.getPurchaseOrdersWithQueriesURL,
    details
  );
  return response;
};

export const getPurchaseOrderHeaderDetails = async (details) => {
  const response = await axios.put(
    endpoints.getPurchaseOrdertHeaderDetailsURL,
    details
  );
  return response;
};

export const getPurchaseOrderReportsForExport = async (filters) => {
  const batchSize = 1500;
  let currentPage = 1;
  let allRecords = [];
  let hasMoreData = true;
  let consecutiveErrors = 0;
  const maxConsecutiveErrors = 3;

  console.log("Starting purchase order export with filters:", filters);

  while (hasMoreData && consecutiveErrors < maxConsecutiveErrors) {
    try {
      console.log(`Fetching page ${currentPage} with batch size ${batchSize}`);
      
      const payload = {
        ...filters,
        page_size: batchSize,
        page_number: currentPage,
      };

      // Remove null, undefined, and empty string values
      const cleanedPayload = Object.fromEntries(
        Object.entries(payload).filter(([key, value]) => {
          return value !== null && 
                value !== undefined && 
                value !== "" && 
                value !== " ".trim();
        })
      );

      const result = await getPurchaseOrderReports(cleanedPayload);

      if (result?.data?.items && result.data.items.length > 0) {
        allRecords = [...allRecords, ...result.data.items];
        consecutiveErrors = 0; // Reset error counter on success
        
        console.log(`Page ${currentPage} fetched successfully. Records so far: ${allRecords.length}`);
        
        // Check if we have more data to fetch
        const totalRecords = result.data.total_records || 0;
        const currentRecordCount = currentPage * batchSize;
        
        if (currentRecordCount >= totalRecords || result.data.items.length < batchSize) {
          hasMoreData = false;
          console.log(`Export completed. Total records fetched: ${allRecords.length}`);
        } else {
          currentPage++;
        }
      } else {
        hasMoreData = false;
        console.log(`No more data available. Page ${currentPage} returned no items.`);
      }
    } catch (error) {
      consecutiveErrors++;
      console.error(`Error fetching page ${currentPage} (attempt ${consecutiveErrors}):`, error);
      
      if (consecutiveErrors >= maxConsecutiveErrors) {
        console.error(`Max consecutive errors reached. Stopping export.`);
        throw new Error(`Failed to fetch data after ${maxConsecutiveErrors} consecutive attempts. Last error: ${error.message}`);
      }
      
      // If we have some data and hit an error, we might want to continue
      if (allRecords.length > 0) {
        console.log(`Continuing export despite error. ${allRecords.length} records fetched so far.`);
        hasMoreData = false; // Stop trying if we have some data
      }
    }
  }

  if (allRecords.length === 0) {
    throw new Error("No data could be fetched for export");
  }

  return {
    success: true,
    data: {
      items: allRecords,
      total_records: allRecords.length
    }
  };
};
